export default __webpack_public_path__ + "static/media/blocksync-logo.9d975577.png";